import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';
import isPasswordConfirmed from '@UI/Pages/Authentication/Shared/FormData/constraint/isPasswordConfirmed';

export type NewPasswordFormArgs = {
	password: string;
	passwordConfirmation: string;
};

/**
 * Shared by the invitation acceptance screen and the password reset screen: both let a visitor
 * choose a new password under the same policy — length only, no composition rule.
 */
@ValidatedClass()
class NewPasswordFormData extends AbstractValidatedClass<NewPasswordFormArgs> {
	@constraint(
		Joi.string().min(12).max(128).required(),
		() => 'Le mot de passe doit contenir entre 12 et 128 caractères.',
	)
	public readonly password: string;

	@constraint(isPasswordConfirmed, 'Les mots de passe ne correspondent pas.')
	public readonly passwordConfirmation: string;

	constructor(data: NewPasswordFormArgs) {
		super(data);
		this.password = data.password;
		this.passwordConfirmation = data.passwordConfirmation;
		Object.freeze(this);
	}

	static createEmpty(): NewPasswordFormData {
		return new NewPasswordFormData({ password: '', passwordConfirmation: '' });
	}

	setPassword(password: string): this {
		return this.cloneWith({ password } as Partial<NewPasswordFormArgs>);
	}

	setPasswordConfirmation(passwordConfirmation: string): this {
		return this.cloneWith({ passwordConfirmation } as Partial<NewPasswordFormArgs>);
	}

	/** `passwordConfirmation` never leaves the browser: it only exists to catch a typo before submission. */
	toCommandData(): { password: string } {
		return { password: this.password };
	}
}

export default NewPasswordFormData;
